export default {
  'en-US': [
    'Year-to-date calculations are based on a calendar year; January 1 to the current month-end date.',
    'Average annualized returns for investment options with an inception date in the past 12 months are cumulative and non-annualized.',
    'The inception date is the first date that the investment option was offered and/or received a contribution.',
  ],
};
